



























import Vue from 'vue'

import { SVGProperties, FindSVG } from '@/api/svg'

import TableView from './table-view.vue'

export default Vue.extend({
  name: 'SettingViews',
  components: {
    TableView,
  },
  data() {
    return {
      svgs: [] as SVGProperties[],
    }
  },
  methods: {
    async find() {
      this.svgs = await FindSVG()
    },
    gotoNew() {
      this.$router.push('/cems/setting/view/create')
    },

    // Toolbar events handler
    async onToolbarRefresh() {
      await this.find()
    },
  },

  async created() {
    await this.find()
  },
})
